import {API} from '../../Services';

async function MallsData(){
    const token = localStorage.getItem('token');
    return API.get(`/users/malls`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}

export {MallsData};